// SetningsMinne/assets/index.js
import {Howl} from 'howler';
import tr0 from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL.mp3';
import tr1 from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL.mp3';

import tr0_ok from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3';
import tr0_ng from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3';
import tr1_ok from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3';
import tr1_ng from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3';

import ok_generic from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3';
import ng_generic from '../../assets/sounds/no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3';

import t0 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-1.mp3';
import t1 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-2.mp3';
import t2 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-3.mp3';
import t3 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-4.mp3';
import t4 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-5.mp3';
import t5 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-6.mp3';
import t6 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-7.mp3';
import t7 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-8.mp3';
import t8 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-9.mp3';
import t9 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-10.mp3';
import t10 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-11.mp3';
import t11 from '../../assets/sounds/no/sentencememory/child/test/grade2-4/SM-ST-12.mp3';

// ---------- NN GRADE 2–4 (trial) ----------
import nn_tr0 from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL.mp3';
import nn_tr1 from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL.mp3';

import nn_tr0_ok from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3';
import nn_tr0_ng from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3';
import nn_tr1_ok from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3';
import nn_tr1_ng from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3';

// generic NN feedback (you can reuse ST1 if you like)
import nn_ok_generic from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3';
import nn_ng_generic from '../../assets/sounds/nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3';

// ---------- NN GRADE 2–4 (test) ----------
import nn_t0 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST1.mp3';
import nn_t1 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST2.mp3';
import nn_t2 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST3.mp3';
import nn_t3 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST4.mp3';
import nn_t4 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST5.mp3';
import nn_t5 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST6.mp3';
import nn_t6 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST7.mp3';
import nn_t7 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST8.mp3';
import nn_t8 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST9.mp3';
import nn_t9 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST10.mp3';
import nn_t10 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST11.mp3';
import nn_t11 from '../../assets/sounds/nn/sentencememory/child/test/grade2-4/ST12.mp3';

// ---------- GRADE 5–7 (new – adjust paths/filenames to your real ones) ----------

import tr0_ok_57 from '../../assets/sounds/no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3';
import tr0_ng_57 from '../../assets/sounds/no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3';
import tr1_ok_57 from '../../assets/sounds/no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-correct.mp3';
import tr1_ng_57 from '../../assets/sounds/no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-wrong.mp3';

import tr0_57 from '../../assets/sounds/no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL.mp3';
import tr1_57 from '../../assets/sounds/no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL.mp3';

import t0_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-1.mp3';
import t1_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-2.mp3';
import t2_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-3.mp3';
import t3_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-4.mp3';
import t4_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-5.mp3';
import t5_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-6.mp3';
import t6_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-7.mp3';
import t7_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-8.mp3';
import t8_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-9.mp3';
import t9_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-10.mp3';
import t10_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-11.mp3';
import t11_57 from '../../assets/sounds/no/sentencememory/child/test/grade5-7/SM-MT-12.mp3';

// ---------- NN GRADE 5–7 (trial) ----------
import nn_tr0_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL.mp3';
import nn_tr1_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL.mp3';

import nn_tr0_ok_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3';
import nn_tr0_ng_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3';
import nn_tr1_ok_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-correct.mp3';
import nn_tr1_ng_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-wrong.mp3';

import nn_ok_generic_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3';
import nn_ng_generic_57 from '../../assets/sounds/nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3';

// ---------- NN GRADE 5–7 (test) ----------
import nn_t0_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT1.mp3';
import nn_t1_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT2.mp3';
import nn_t2_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT3.mp3';
import nn_t3_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT4.mp3';
import nn_t4_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT5.mp3';
import nn_t5_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT6.mp3';
import nn_t6_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT7.mp3';
import nn_t7_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT2.mp3'; // TODO:: MT8.mp3 is missing. need to add it
import nn_t8_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT9.mp3';
import nn_t9_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT10.mp3';
import nn_t10_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT11.mp3';
import nn_t11_57 from '../../assets/sounds/nn/sentencememory/child/test/grade5-7/MT12.mp3';

// --------- YOUTH (NO) ---------

// trial
import y_tr0 from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-1.mp3';
import y_tr1 from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-2.mp3';

import y_tr0_ok from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-1-if-correct.mp3';
import y_tr0_ng from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-1-if-wrong.mp3';
import y_tr1_ok from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-2-if-correct-kopi.mp3';
import y_tr1_ng from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-2-if-wrong.mp3';

// generic fallback for youth trial feedback
import y_ok_generic from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-1-if-correct.mp3';
import y_ng_generic from '../../assets/sounds/no/sentencememory/youth/trial/TRIAL-1-if-wrong.mp3';

// test (15 sentences)
import y_t0 from '../../assets/sounds/no/sentencememory/youth/test/S-1-Y.mp3';
import y_t1 from '../../assets/sounds/no/sentencememory/youth/test/S-2-Y.mp3';
import y_t2 from '../../assets/sounds/no/sentencememory/youth/test/S-3-Y.mp3';
import y_t3 from '../../assets/sounds/no/sentencememory/youth/test/S-4-Y.mp3';
import y_t4 from '../../assets/sounds/no/sentencememory/youth/test/S-5-Y.mp3';
import y_t5 from '../../assets/sounds/no/sentencememory/youth/test/S-6-Y.mp3';
import y_t6 from '../../assets/sounds/no/sentencememory/youth/test/S-7-Y.mp3';
import y_t7 from '../../assets/sounds/no/sentencememory/youth/test/S-8-Y.mp3';
import y_t8 from '../../assets/sounds/no/sentencememory/youth/test/S-9-Y.mp3';
import y_t9 from '../../assets/sounds/no/sentencememory/youth/test/S-10-Y.mp3';
import y_t10 from '../../assets/sounds/no/sentencememory/youth/test/S-11-Y.mp3';
import y_t11 from '../../assets/sounds/no/sentencememory/youth/test/S-12-Y.mp3';
import y_t12 from '../../assets/sounds/no/sentencememory/youth/test/S-13-Y.mp3';
import y_t13 from '../../assets/sounds/no/sentencememory/youth/test/S-14-Y.mp3';
import y_t14 from '../../assets/sounds/no/sentencememory/youth/test/S-15-Y.mp3';

// --------- YOUTH (NN) ---------

// trial
import nn_y_tr0 from '../../assets/sounds/nn/sentencememory/youth/trail/TRIAL 1.mp3';
import nn_y_tr1 from '../../assets/sounds/nn/sentencememory/youth/trail/TRIAL 2.mp3';

import nn_y_tr0_wrong from '../../assets/sounds/nn/sentencememory/youth/trail/TRIAL 1-if-wrong.mp3';
import nn_y_tr1_wrong from '../../assets/sounds/nn/sentencememory/youth/trail/TRIAL 2-if-wrong.mp3';

// test (15 sentences)
import nn_y_t0 from '../../assets/sounds/nn/sentencememory/youth/test/Y1.mp3';
import nn_y_t1 from '../../assets/sounds/nn/sentencememory/youth/test/Y2.mp3';
import nn_y_t2 from '../../assets/sounds/nn/sentencememory/youth/test/Y3.mp3';
import nn_y_t3 from '../../assets/sounds/nn/sentencememory/youth/test/Y4.mp3';
import nn_y_t4 from '../../assets/sounds/nn/sentencememory/youth/test/Y5.mp3';
import nn_y_t5 from '../../assets/sounds/nn/sentencememory/youth/test/Y6.mp3';
import nn_y_t6 from '../../assets/sounds/nn/sentencememory/youth/test/Y7.mp3';
import nn_y_t7 from '../../assets/sounds/nn/sentencememory/youth/test/Y8.mp3';
import nn_y_t8 from '../../assets/sounds/nn/sentencememory/youth/test/Y9.mp3';
import nn_y_t9 from '../../assets/sounds/nn/sentencememory/youth/test/Y10.mp3';
import nn_y_t10 from '../../assets/sounds/nn/sentencememory/youth/test/Y11.mp3';
import nn_y_t11 from '../../assets/sounds/nn/sentencememory/youth/test/Y12.mp3';
import nn_y_t12 from '../../assets/sounds/nn/sentencememory/youth/test/Y13.mp3';
import nn_y_t13 from '../../assets/sounds/nn/sentencememory/youth/test/Y14.mp3';
import nn_y_t14 from '../../assets/sounds/nn/sentencememory/youth/test/Y15.mp3';

// --------- ADULT (NO) ---------

// trial
import a_tr0 from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL 1.mp3';
import a_tr1 from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL 2.mp3';

import a_tr0_ok from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL 1-if-correct.mp3';
import a_tr0_ng from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL1-If-wrong.mp3';
import a_tr1_ok from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL 2-if-correct-kopi.mp3';
import a_tr1_ng from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL 2-if-wrong.mp3';

// generic fallbacks for adult trial feedback
import a_ok_generic from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL 1-if-correct.mp3';
import a_ng_generic from '../../assets/sounds/no/sentencememory/adult/trial/A TRIAL1-If-wrong.mp3';

// test (15 sentences)
import a_t0 from '../../assets/sounds/no/sentencememory/adult/test/S-1.mp3';
import a_t1 from '../../assets/sounds/no/sentencememory/adult/test/S-2.mp3';
import a_t2 from '../../assets/sounds/no/sentencememory/adult/test/S-3.mp3';
import a_t3 from '../../assets/sounds/no/sentencememory/adult/test/S-4.mp3';
import a_t4 from '../../assets/sounds/no/sentencememory/adult/test/S-5.mp3';
import a_t5 from '../../assets/sounds/no/sentencememory/adult/test/S-6.mp3';
import a_t6 from '../../assets/sounds/no/sentencememory/adult/test/S-7.mp3';
import a_t7 from '../../assets/sounds/no/sentencememory/adult/test/S-8.mp3';
import a_t8 from '../../assets/sounds/no/sentencememory/adult/test/S-9.mp3';
import a_t9 from '../../assets/sounds/no/sentencememory/adult/test/S-10.mp3';
import a_t10 from '../../assets/sounds/no/sentencememory/adult/test/S-11.mp3';
import a_t11 from '../../assets/sounds/no/sentencememory/adult/test/S-12.mp3';
import a_t12 from '../../assets/sounds/no/sentencememory/adult/test/S-13.mp3';
import a_t13 from '../../assets/sounds/no/sentencememory/adult/test/S-14.mp3';
import a_t14 from '../../assets/sounds/no/sentencememory/adult/test/S-15.mp3';

// --------- ADULT (NN) ---------

// trial
import nn_a_tr0 from '../../assets/sounds/nn/sentencememory/adult/trial/TASK 1.mp3';
import nn_a_tr1 from '../../assets/sounds/nn/sentencememory/adult/trial/TASK 2.mp3';

import nn_a_tr0_wrong from '../../assets/sounds/nn/sentencememory/adult/trial/TASK 1 if-wrong.mp3';
import nn_a_tr1_wrong from '../../assets/sounds/nn/sentencememory/adult/trial/TASK 2 if wrong.mp3';

// test (15 sentences)
import nn_a_t0 from '../../assets/sounds/nn/sentencememory/adult/test/A1.mp3';
import nn_a_t1 from '../../assets/sounds/nn/sentencememory/adult/test/A2.mp3';
import nn_a_t2 from '../../assets/sounds/nn/sentencememory/adult/test/A3.mp3';
import nn_a_t3 from '../../assets/sounds/nn/sentencememory/adult/test/A4.mp3';
import nn_a_t4 from '../../assets/sounds/nn/sentencememory/adult/test/A5.mp3';
import nn_a_t5 from '../../assets/sounds/nn/sentencememory/adult/test/A6.mp3';
import nn_a_t6 from '../../assets/sounds/nn/sentencememory/adult/test/A7.mp3';
import nn_a_t7 from '../../assets/sounds/nn/sentencememory/adult/test/A8.mp3';
import nn_a_t8 from '../../assets/sounds/nn/sentencememory/adult/test/A9.mp3';
import nn_a_t9 from '../../assets/sounds/nn/sentencememory/adult/test/A10.mp3';
import nn_a_t10 from '../../assets/sounds/nn/sentencememory/adult/test/A11.mp3';
import nn_a_t11 from '../../assets/sounds/nn/sentencememory/adult/test/A12.mp3';
import nn_a_t12 from '../../assets/sounds/nn/sentencememory/adult/test/A13.mp3';
import nn_a_t13 from '../../assets/sounds/nn/sentencememory/adult/test/A14.mp3';
import nn_a_t14 from '../../assets/sounds/nn/sentencememory/adult/test/A15.mp3';

const mk = (url) => new Howl({src: [url], preload: true, html5: true});

const objFromArray = (urls) =>
	urls.reduce((acc, url, i) => {
		acc[i] = mk(url);
		return acc;
	}, {});

// ---------- trial prompts ----------
const no_sm_trial_2_4 = objFromArray([tr0, tr1]);
const no_sm_trial_5_7 = objFromArray([tr0_57, tr1_57]);

// ---------- test sentences ----------
const no_sentences_2_4 = objFromArray([
	t0,
	t1,
	t2,
	t3,
	t4,
	t5,
	t6,
	t7,
	t8,
	t9,
	t10,
	t11,
]);
const no_sentences_5_7 = objFromArray([
	t0_57,
	t1_57,
	t2_57,
	t3_57,
	t4_57,
	t5_57,
	t6_57,
	t7_57,
	t8_57,
	t9_57,
	t10_57,
	t11_57,
]);

// NN trial prompts
const nn_sm_trial_2_4 = objFromArray([nn_tr0, nn_tr1]);
const nn_sm_trial_5_7 = objFromArray([nn_tr0_57, nn_tr1_57]);

// NN test sentences
const nn_sentences_2_4 = objFromArray([
	nn_t0,
	nn_t1,
	nn_t2,
	nn_t3,
	nn_t4,
	nn_t5,
	nn_t6,
	nn_t7,
	nn_t8,
	nn_t9,
	nn_t10,
	nn_t11,
]);
const nn_sentences_5_7 = objFromArray([
	nn_t0_57,
	nn_t1_57,
	nn_t2_57,
	nn_t3_57,
	nn_t4_57,
	nn_t5_57,
	nn_t6_57,
	nn_t7_57,
	nn_t8_57,
	nn_t9_57,
	nn_t10_57,
	nn_t11_57,
]);

// ---------- YOUTH PACKS (NO/NN) ----------

// trial prompts
const no_youth_trial = objFromArray([y_tr0, y_tr1]);

// test sentences (15)
const no_youth_sentences = objFromArray([
	y_t0,
	y_t1,
	y_t2,
	y_t3,
	y_t4,
	y_t5,
	y_t6,
	y_t7,
	y_t8,
	y_t9,
	y_t10,
	y_t11,
	y_t12,
	y_t13,
	y_t14,
]);

const nn_youth_trial = objFromArray([nn_y_tr0, nn_y_tr1]);

const nn_youth_sentences = objFromArray([
	nn_y_t0,
	nn_y_t1,
	nn_y_t2,
	nn_y_t3,
	nn_y_t4,
	nn_y_t5,
	nn_y_t6,
	nn_y_t7,
	nn_y_t8,
	nn_y_t9,
	nn_y_t10,
	nn_y_t11,
	nn_y_t12,
	nn_y_t13,
	nn_y_t14,
]);

// ---------- ADULT PACKS (NO) ----------

// trial prompts
const no_adult_trial = objFromArray([a_tr0, a_tr1]);
const nn_adult_trial = objFromArray([nn_a_tr0, nn_a_tr1]);

// test sentences (15)
const no_adult_sentences = objFromArray([
	a_t0,
	a_t1,
	a_t2,
	a_t3,
	a_t4,
	a_t5,
	a_t6,
	a_t7,
	a_t8,
	a_t9,
	a_t10,
	a_t11,
	a_t12,
	a_t13,
	a_t14,
]);

const nn_adult_sentences = objFromArray([
	nn_a_t0,
	nn_a_t1,
	nn_a_t2,
	nn_a_t3,
	nn_a_t4,
	nn_a_t5,
	nn_a_t6,
	nn_a_t7,
	nn_a_t8,
	nn_a_t9,
	nn_a_t10,
	nn_a_t11,
	nn_a_t12,
	nn_a_t13,
	nn_a_t14,
]);

// ---------- FEEDBACK CLIPS (grade-specific) ----------
const no_sm_answers_2_4 = {
	correct1: mk(tr0_ok),
	incorrect1: mk(tr0_ng),
	correct2: mk(tr1_ok),
	incorrect2: mk(tr1_ng),
	// generic fallbacks
	correct: mk(ok_generic),
	incorrect: mk(ng_generic),
};

const no_sm_answers_5_7 = {
	correct1: mk(tr0_ok_57),
	incorrect1: mk(tr0_ng_57),
	correct2: mk(tr1_ok_57),
	incorrect2: mk(tr1_ng_57),
	// generic fallbacks for upper grades – use MT1 clips
	correct: mk(tr0_ok_57),
	incorrect: mk(tr0_ng_57),
};

const nn_sm_answers_2_4 = {
	correct1: mk(nn_tr0_ok),
	incorrect1: mk(nn_tr0_ng),
	correct2: mk(nn_tr1_ok),
	incorrect2: mk(nn_tr1_ng),
	correct: mk(nn_ok_generic),
	incorrect: mk(nn_ng_generic),
};

const nn_sm_answers_5_7 = {
	correct1: mk(nn_tr0_ok_57),
	incorrect1: mk(nn_tr0_ng_57),
	correct2: mk(nn_tr1_ok_57),
	incorrect2: mk(nn_tr1_ng_57),
	correct: mk(nn_ok_generic_57),
	incorrect: mk(nn_ng_generic_57),
};

const no_youth_answers = {
	correct1: mk(y_tr0_ok),
	incorrect1: mk(y_tr0_ng),
	correct2: mk(y_tr1_ok),
	incorrect2: mk(y_tr1_ng),
	// generic fallbacks
	correct: mk(y_ok_generic),
	incorrect: mk(y_ng_generic),
};

const nn_youth_answers = {
	correct1: mk(nn_y_tr0),
	incorrect1: mk(nn_y_tr0_wrong),
	correct2: mk(nn_y_tr1),
	incorrect2: mk(nn_y_tr1_wrong),
	// generic fallbacks
	correct: mk(nn_y_tr0),
	incorrect: mk(nn_y_tr0_wrong),
};

const no_adult_answers = {
	correct1: mk(a_tr0_ok),
	incorrect1: mk(a_tr0_ng),
	correct2: mk(a_tr1_ok),
	incorrect2: mk(a_tr1_ng),
	// generic fallbacks
	correct: mk(a_ok_generic),
	incorrect: mk(a_ng_generic),
};

const nn_adult_answers = {
	correct1: mk(nn_a_tr0),
	incorrect1: mk(nn_a_tr0_wrong),
	correct2: mk(nn_a_tr1),
	incorrect2: mk(nn_a_tr1_wrong),
	correct: mk(nn_a_tr0),
	incorrect: mk(nn_a_tr0_wrong),
};

// keep the old exports (they now mean “2–4 pack”)
export const no_sm_answers = no_sm_answers_2_4;
export const nn_sm_answers = nn_sm_answers_2_4;

// ---------- shared grade helper ----------
const isUpperGrade = (ageGroup) => {
	const g = Number(ageGroup);
	return Number.isFinite(g) && g >= 5 && g <= 7;
};

// ---------- API helpers ----------
export const getTrialAudioPack = (langCode, ageGroup, testKeyType) => {
	const upper = isUpperGrade(ageGroup);
	const isNn = langCode === 'nn';

	// Youth-followup: ignore grade; use youth pack
	if (testKeyType === 'youth-followup') {
		return isNn ? nn_youth_trial : no_youth_trial;
	}

	// Adult followup
	if (testKeyType === 'adult-followup') {
		return isNn ? nn_adult_trial : no_adult_trial;
	}

	// Child (current logic)
	if (isNn) {
		if (upper && nn_sm_trial_5_7) return nn_sm_trial_5_7;
		return nn_sm_trial_2_4;
	}

	if (upper && no_sm_trial_5_7) return no_sm_trial_5_7;
	return no_sm_trial_2_4;
};

export const getTestAudioPack = (langCode, ageGroup, testKeyType) => {
	const upper = isUpperGrade(ageGroup);
	const isNn = langCode === 'nn';

	// Youth-followup: 15-sentence set
	if (testKeyType === 'youth-followup') {
		return isNn ? nn_youth_sentences : no_youth_sentences;
	}

	// Adult followup
	if (testKeyType === 'adult-followup') {
		return isNn ? nn_adult_sentences : no_adult_sentences;
	}

	// Child (current logic)
	if (isNn) {
		if (upper && nn_sentences_5_7) return nn_sentences_5_7;
		return nn_sentences_2_4;
	}

	if (upper && no_sentences_5_7) return no_sentences_5_7;
	return no_sentences_2_4;
};

export const getTrialFeedbackPack = (langCode, ageGroup, testKeyType) => {
	const upper = isUpperGrade(ageGroup);
	const isNn = langCode === 'nn';

	// Adult followup
	if (testKeyType === 'adult-followup') {
		return isNn ? nn_adult_answers : no_adult_answers;
	}

	// Youth-followup
	if (testKeyType === 'youth-followup') {
		return isNn ? nn_youth_answers : no_youth_answers;
	}

	// Child (current)
	if (isNn) {
		return upper ? nn_sm_answers_5_7 : nn_sm_answers_2_4;
	}
	return upper ? no_sm_answers_5_7 : no_sm_answers_2_4;
};

// Optional backwards-compat exports
export const no_sm_trial = no_sm_trial_2_4;
export const nn_sm_trial = nn_sm_trial_2_4;
export const no_sentences = no_sentences_2_4;
export const nn_sentences = nn_sentences_2_4;
